var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-block--wrapper"},[(_vm.showContent && _vm.text)?_c('div',{staticClass:"bottom-block--text"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }